<template>
  <div>
    <template v-if="isFromApproval">
      <b-button variant="success" size="sm" @click="openModal">
        <i class="fa fa-check"></i>
      </b-button>
    </template>
    <template v-else>
      <b-button variant="primary" size="sm" @click="openModal" class="rounded">
        <i class="fa fa-edit"></i> Edit
      </b-button>
    </template>

    <b-modal :id="modalId" :title="modalTitle" no-close-on-backdrop no-close-on-esc :hide-header-close="loading" :size="size">
      <template>
        <component :is="size ? 'b-row' : 'div'">
          <component :is="size ? 'b-col' : 'div'" :cols="size ? 12 : null" :md="size ? 6 : null">
            <div class="mb-3">
              <p class="mb-0">{{ label }} Lama</p>
              <p class="mb-0 font-600">{{ currentValue }}</p>
            </div>

            <b-form-group :label="`${label} Baru`" label-for="input-baru">
              <b-form-input
                id="input-baru"
                v-model.trim="form.newValue"
                :type="inputType"
                :placeholder="`Masukkan ${label} baru...`"
                required
              />
            </b-form-group>

            <b-form-group :label="isFromApproval ? 'Alasan Setuju' : 'Alasan'">
              <b-form-textarea
                v-model="form.notes"
                placeholder="Contoh: Salah ketik..."
                rows="4"
                maxlength="100"
              />
            </b-form-group>

            <FotoPendukung
              v-if="!size && showUpload"
              :isNotShowCam="true"
              :fotoPendukung="form.fotoPendukung"
              :length="1"
              :minLength="1"
              @showModalPreview="openModalPreview"
              @onChange="onChangeFoto"
            />
          </component>

          <component
            v-if="imageUrl"
            :is="size ? 'b-col' : 'div'"
            :cols="size ? 12 : null"
            :md="size ? 6 : null" 
            class="mt-3 mt-md-0"
          >
            <label class="d-block mb-2 font-weight-bold">Lampiran</label>
            <div class="image-preview-box" @click="openImageInNewTab" style="cursor: pointer;">
              <img 
                :src="imageUrl" 
                class="preview-img" 
                alt="Lampiran"
              />
            </div>
          </component>
        </component>
      </template>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()" :disabled="loading">
          Batal
        </b-button>
        <b-button variant="primary" @click="handleSubmit" :disabled="loading || !form.newValue">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ isFromApproval ? 'Setujui' : 'Kirim Pengajuan' }}
        </b-button>
      </template>
    </b-modal>

    <ModalPreview :modalId="`modal-preview-field-approval-${this.fieldKey}`" :fotoPreview="activeFotoPreview" />
  </div>
</template>

<script>
import ModalPreview from "@/components/webcam/ModalPreview";
import FotoPendukung from '@/components/webcam/FotoPendukung'

export default {
  name: 'FieldApproval',
  components: {
    ModalPreview,
    FotoPendukung,
  },
  props: {
    label: { type: String, required: true },
    currentValue: { type: [String, Number], default: '' },
    newValue: { type: [String, Number], default: '' },
    notesValue: { type: [String], default: '' },
    fieldKey: { type: String, required: true },
    inputType: { type: String, default: 'text' },
    loading: { type: Boolean, default: false },
    isFromApproval: { type: Boolean, default: false },
    selectedRow: { type: Object, default: () => ({}) },
    showUpload: { type: Boolean, default: false },
    imageUrl: { type: String, default: '' },
    size: { type: String, default: '' },
  },
  data() {
    return {
      form: {
        newValue: '',
        notes: '',
        fotoPendukung: {
          index: 0,
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          urlFotoBarangPendukung: null,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Pilih Foto",
        },
        fotoPendukungUrl: [],
      },
      activeFotoPreview: '',
    }
  },
  computed: {
    modalId() {
      return `modal-approval-${this.fieldKey}`;
    },
    modalTitle() {
      if (this.isFromApproval) {
        return 'Persetujuan Edit Anggota'
      }

      return `Ajukan Perubahan ${this.label}`
    },
  },
  methods: {
    openModal() {
      this.form.newValue = this.newValue ? this.newValue : '';
      this.form.notes = this.notesValue ? this.notesValue : '';
      this.form.fotoPendukung = {
        index: 0,
        fotoBarangPendukung: null,
        fotoBarangPendukungBase64: null,
        activeFotoPendukungBase64: null,
        urlFotoBarangPendukung: null,
        checkFotoBarangPendukung: false,
        fotoBarangPendukungPlaceholder: "Pilih Foto",
      }
      this.form.fotoPendukungUrl = []
      this.activeFotoPreview = ''

      this.$bvModal.show(this.modalId);
    },
    handleSubmit() {
      this.$emit('submit', {
        key: this.fieldKey,
        oldValue: this.currentValue,
        newValue: this.form.newValue,
        notes: this.form.notes,
        row: this.selectedRow,
        attachments: this.form.fotoPendukungUrl,
      });
    },
    openModalPreview() {
      this.activeFotoPreview = this.form.fotoPendukung.activeFotoPendukungBase64
      this.$bvModal.show(`modal-preview-field-approval-${this.fieldKey}`)
    },
    openImageInNewTab() {
      if(this.imageUrl) {
        window.open(this.imageUrl, '_blank');
      }
    },
    async onChangeFoto(file, index) {
      const fileUpload = this.$helper.createSafeFileCopy(file)
      const path = 'nasabah/create-presigned-url-nasabah-edit';
      const params = { nasabahId: this.selectedRow.id, value: 'no_handphone_sekarang' };

      this.$store.dispatch("loading/show")
      const response = await this.$helper.uploadPresigned({ vue: this, path, params, fileUpload })
      this.$store.dispatch("loading/hide")

      if (!response.success) {
        this.form.fotoPendukung = {
          index: index,
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
          urlFotoBarangPendukung: null,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Pilih Foto",
        };

        this.$helper.toastErr(this, "Gagal upload foto. Silakan coba lagi.");
        return;
      }

      const baseUrl = this.$baseFilePathAws;
      let url = response.publicUrl;
      if (url.startsWith(baseUrl)) {
        url = url.slice(baseUrl.length);
      }
      this.form.fotoPendukungUrl = [url];
    },
  },
}
</script>

<style scoped>
.image-preview-box {
  background-color: #f8f9fa;
  border: 1px dashed #ced4da;
  border-radius: 8px;
  height: 350px; 
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.btn-zoom {
  position: absolute;
  bottom: 10px;
  right: 10px;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .image-preview-box {
    height: 250px;
  }
}
</style>